import {
  type ApiRoleStrategy,
  ROLES,
  api,
  useQuery,
  useRoleConf,
} from "@pharmupp/p3-front-commons"

export const useCommitteePlatform = () => {
  const { queryKey, endpoint } = useRoleConf(committeeListRoleConf)
  return useQuery<APICommitteeMember[], unknown, CommitteeMember[]>({
    queryKey,
    queryFn: () => api.get<APICommitteeMember[]>(endpoint),
    select: (members) =>
      members.map(({ user, ...member }) => ({
        ...member,
        user: {
          ...user,
          firstName: user.firstName ?? "",
          lastName: user.lastName ?? "",
        },
      })),
  })
}

export const committeeListRoleConf: ApiRoleStrategy = {
  [ROLES.ADHERENT_HOLDER]: {
    endpoint: "/api/employee-committees/adherent/members",
    queryKey: ["employee-committees", "adherent", "members"],
  },
}

export interface APICommitteeUser {
  id: string
  firstName?: string | null
  lastName?: string | null
  email: string
  role: "ADHERENT_HOLDER" | "ADHERENT_TEAM"
}

export interface APICommitteeMember {
  user: APICommitteeUser
  isActive: boolean
  isActivatable: boolean
  isCurrentUser: boolean
}

export interface CommitteeMember extends APICommitteeMember {
  user: Omit<APICommitteeUser, "firstName" | "lastName"> & {
    firstName: string
    lastName: string
  }
}
